export default {
  headerName: 'Nome',
  headerCode: 'Código',
  headerActions: 'Ações'
}
